import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
// components

import IndexDropdown from 'components/Dropdowns/IndexDropdown'

export default function Navbar(props) {
	const [navbarOpen, setNavbarOpen] = React.useState(false)
	return (
		<>
			<nav className='top-0 absolute z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg'>
				<div className='container px-4 mx-auto flex flex-wrap items-center justify-between'>
					<div className='w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start'>
						<Link legacyBehavior href='/'>
							<a className='text-white text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase'>
								<div className='w-8'>
									<Image
										src={'/img/icon-white.png'}
										width={40}
										height={40}
										alt='Xisaabiye'
									/>
								</div>
							</a>
						</Link>
						<button
							className='cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none'
							type='button'
							onClick={() => setNavbarOpen(!navbarOpen)}
						>
							<i className='text-white fas fa-bars'></i>
						</button>
					</div>
					<div
						className={
							'lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none' +
							(navbarOpen ? ' block rounded shadow-lg' : ' hidden')
						}
						id='example-navbar-warning'
					>
						<ul className='flex flex-col lg:flex-row list-none mr-auto'>
							<li className='flex items-center'>
								<Link legacyBehavior href='/' passHref>
									<a className='lg:text-white lg:hover:text-slate-200 text-slate-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold'>
										Home
									</a>
								</Link>
							</li>
							<li className='flex items-center'>
								<Link legacyBehavior href='/about' passHref>
									<a className='lg:text-white lg:hover:text-slate-200 text-slate-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold'>
										About us
									</a>
								</Link>
							</li>
						</ul>
						<ul className='flex flex-col lg:flex-row list-none lg:ml-auto'>
							<li className='flex items-center'>
								<a
									className='lg:text-white lg:hover:text-slate-200 text-slate-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold'
									href='https://www.facebook.com/xisaabiye'
									target='_blank'
								>
									<i className='lg:text-slate-200 text-slate-400 fab fa-facebook text-lg leading-lg ' />
									<span className='lg:hidden inline-block ml-2'>Share</span>
								</a>
							</li>

							<li className='flex items-center'>
								<a
									className='lg:text-white lg:hover:text-slate-200 text-slate-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold'
									href='https://twitter.com/xisaabiye'
									target='_blank'
								>
									<i className='lg:text-slate-200 text-slate-400 fab fa-twitter text-lg leading-lg ' />
									<span className='lg:hidden inline-block ml-2'>Tweet</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</>
	)
}
